<template>
  <div>
    <upload-image @uploadChange="uploadChange" :imageInit="imageUrl" :imageCount="0" :showUploadList="false" :fileListInit="[]" @cancelFile="cancelFile" :signalCla="true">
    </upload-image>

    <upload-image @uploadChange="uploadChange" :fileListInit="fileList4" :imageCount="1" @cancelFile="cancelFile" :multiple="multiple">
    </upload-image>

    <upload-image @uploadChange="uploadChange" :fileListInit="fileList" :imageCount="6" @cancelFile="cancelFile" :multiple="multiple">
    </upload-image>

    <upload-image @uploadChange="uploadChange" :fileListInit="fileList2" :imageCount="3" :listType="listType" @cancelFile="cancelFile" :fleft="true">
    </upload-image>

    <upload-image @uploadChange="uploadChange" :fileListInit="fileList3" :imageCount="4" :listType="listType" @cancelFile="cancelFile">
    </upload-image>

  </div>

</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      imageUrl: "",

      fileList4: [],

      fileList: [],
      multiple: true,

      listType: "text",
      fileList2: [],

      fileList3: []
    };
  },
  mounted() {},

  methods: {
    loadimage() {},
    uploadingChange(file) {},
    uploadChange(file) {},
    cancelFile(file) {}
  }
};
</script>

<style lang="scss">
</style>





// WEBPACK FOOTER //
// src/router/wait/index.vue